module.exports = __webpack_public_path__ + "08f79849cfa4277d47a5de0d70c8ea77.svg";